import React from "react";
import { Control, UseFormGetValues, UseFormSetValue, UseFormWatch } from "react-hook-form";
import { Spacing } from "../../../config";
import { AccessTime } from "@material-ui/icons";
import { validations } from "../../../utils";
import masks from "../../../utils/masks";
import { CustomText } from "../../../components/index";
import { api } from "../../../services";
import { hooks } from "../../../utils";
import ResponseError from "../../../services/helpers/ResponseError";
import alerts from "../../../utils/alerts";
import errorStatusMessage from "../../../services/helpers/errorStatusMessage";
import Grid, { GridSize } from "@material-ui/core/Grid";
import {
  Input,
  InputDate,
} from "../../../components/inputs/newForm";

export interface ChechkInAndOutProps {
  control: Control<any>;
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  oldData?: any;
  edit?: boolean;
  customGrid?: { xs: GridSize, md: GridSize, lg: GridSize }
}

export default function ChechkInAndOut({
  control,
  watch,
  setValue,
  getValues,
  oldData,
  edit,
  customGrid
}: ChechkInAndOutProps) {
  const [hourError, setHourError] = React.useState<any>(null);
  const [warning, setWarning] = React.useState<any>(null);
  const { loading, call } = hooks.useRequest();

  const [minDate, setMinDate] = React.useState<any>(() => {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  });
  const [timeError, setTimeError] = React.useState<any>(false);

  function isValidDate(date: any): boolean {
    const parsedDate = new Date(date);
    return parsedDate instanceof Date && !isNaN(parsedDate.getTime());
  }

  const validadeTime = () => {
    const property = getValues("property");
    const localId = Array.isArray(property) ? property[0]?.value : undefined;
    const startDate = getValues("startDate");
    const endDate = getValues("endDate");
    const startHour = getValues("checkInTime");
    const endHour = getValues("checkOutTime");

    const timeEndError = validations.validateTimeRange(endHour);
    const timeStartHour = validations.validateTimeRange(startHour);

    if (
      !timeEndError &&
      !timeStartHour &&
      isValidDate(startDate) &&
      isValidDate(endDate) &&
      localId &&
      endDate &&
      endHour &&
      startDate &&
      startHour
    ) {
      const startSub = masks.dateToSubmit(startDate) + " " + startHour;
      const endSub = masks.dateToSubmit(endDate) + " " + endHour;

      const subData: any = {
        placeId: localId,
        startDate: startSub,
        endDate: endSub,
      };

      if (edit) subData["reservationId"] = oldData.id;

      call(
        null,
        api.validadeTime(subData),
        (response) => {
          if (response?.ok) {
            setHourError(null);
            if (response?.data?.value === true)
              setWarning("Esse horário esta em uso");
          }
        },
        (response) => {
          const errorResponse = new ResponseError(response);
          if (errorResponse.message) {
            setHourError(errorResponse.message);
          } else {
            const errorMsg = errorStatusMessage(response);
            alerts.alertError(errorMsg);
            setHourError(
              "*Não foi possível validar o horário. Tente Novamente"
            );
          }
        }
      );
    } else {
      setHourError("Selecione um Local e Período");
    }
  };

  return (
    <Grid item alignItems="flex-start" xs={customGrid?.xs ?? 12} md={customGrid?.md ?? 12} lg={customGrid?.lg  ?? 6}>
      <Grid container alignItems="flex-start" spacing={2}>
        <Grid
          item
          xs={12} md={12} lg={6}
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: "0.5rem",
          }}
        >
          <InputDate
            control={control}
            name="startDate"
            label="Check-in"
            minDate={new Date()}
            onFieldBlur={validadeTime}
            onDateChange={(value) => {
              setMinDate(value);
              const end = getValues("endDate");
              if (end && value && end < value) {
                setValue("endDate", null);
              }
              if (value && oldData?.startDate) {
                const sameAsOld =
                  value + "" === new Date(oldData.startDate) + "";
                if (!sameAsOld) {
                  const error = validations.inputDate(value, undefined, new Date());
                  setTimeError(error ? "*Período invalido" : null);
                } else {
                  setTimeError(null);
                }
              }
            }}
          />
          <Input
            label="ㅤ"
            control={control}
            name="checkInTime"
            mask={masks.formatHour}
            placeholder="00:00"
            endAdornment={<AccessTime style={{ fontSize: Spacing(2) }} />}
            onBlur={validadeTime}
          />
        </Grid>

        <Grid
          item
          xs={12} md={12} lg={6}
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: "0.5rem",
          }}
        >
          <InputDate
            control={control}
            name="endDate"
            label="Check-out"
            minDate={minDate}
            onFieldBlur={validadeTime}
            onDateChange={(value) => {
              if (value) {
                const error = validations.inputDate(value, undefined, minDate);
                setTimeError(error ? "*Período invalido" : null);
              }
            }}
          />
          <Input
            label="ㅤ"
            control={control}
            name="checkOutTime"
            mask={masks.formatHour}
            placeholder="00:00"
            endAdornment={<AccessTime style={{ fontSize: Spacing(2) }} />}
            onBlur={validadeTime}
          />
        </Grid>

        {(hourError || warning || timeError) && (
          <Grid item xs={12}>
            <CustomText
              style={{ whiteSpace: "pre-wrap" }}
              fontSize={1.75}
              textColor="#ff7733"
            >
              {timeError && timeError + "\n"}
              {hourError && "*" + hourError}
              {warning && "*" + warning}
            </CustomText>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
